import Navbar from "../Components/Navbar";
import RoomCards from "../Components/RoomCards";
import Footer from "../Components/Footer";
import ResidencyImages from "../Components/ResidencyImages";

function Rooms() {
  return (
    <>
      <Navbar />
      <RoomCards />
      <ResidencyImages />
      <Footer />
    </>
  );
}

export default Rooms;